import React from 'react'

import { Box, Paper, Grid } from '@mui/material'

import { CompanyLocationItem } from './CompanyLocationItem'

import { GetCompanyByIdQuery } from '@edge/spark/io-dashboards'

interface Props {
    data: GetCompanyByIdQuery | undefined
}

export const CompanyLocationsWidget: React.FC<Props> = ({ data }: Props) => {
    const { locations } = data?.auction?.accounts?.byId ?? {}

    return (
        <Box
            sx={{
                flexGrow: 1,
                padding: '1px 5px',
                overflow: 'auto',
                minWidth: '100%',
                minHeight: '250px', // Accommodating for scroll bar on sibling.
            }}
        >
            <Grid
                container
                direction="column"
                component={Paper}
                elevation={2}
                sx={{ p: 2, width: '100%', minHeight: '240px' }}
            >
                {locations?.map((location) => {
                    return location ? <CompanyLocationItem key={location.id} location={location} /> : null
                }) ?? []}
            </Grid>
        </Box>
    )
}
